import { Action } from '../../../common/actions/core/action';
import { ListeningPackageSegment } from '../../../common/services/package/package.model';

export class OpenDoubleOptSuccessDialogAction implements Action {
  constructor(
    public type: ListeningPackageSegment
  ) {}
}



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/success/double-opt-success-dialog.action.ts